import { useTranslation } from 'react-i18next';
import styles from './DocumentTable.module.css';

// Enough to fill a tall pane; each row is fainter than the one before, so the
// run trails off instead of ending at a count that pretends to know how many
// files are coming.
const ROWS = 14;

const NAME_WIDTHS = ['78%', '62%', '85%', '54%', '70%', '60%', '80%'];

/** Loading placeholder for the documents table — matches its column layout. */
export function DocumentTableSkeleton() {
  const { t } = useTranslation();
  return (
    <div className={styles.tableWrap} aria-hidden="true">
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={`${styles.th} ${styles.colName}`}>{t('documents.col.name')}</th>
            <th className={`${styles.th} ${styles.colDesc}`}>{t('documents.col.description')}</th>
            <th className={`${styles.th} ${styles.colVersion}`}>{t('documents.col.version')}</th>
            <th className={`${styles.th} ${styles.colStatus}`}>{t('documents.col.status')}</th>
            <th className={`${styles.th} ${styles.colSize}`}>{t('documents.col.size')}</th>
            <th className={`${styles.th} ${styles.colUpdated}`}>{t('documents.col.updated')}</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: ROWS }, (_, i) => (
            // The fade is the row's own opacity; the pulse animates the bars.
            <tr key={i} className={styles.skeletonRow} style={{ '--slot': i } as React.CSSProperties}>
              <td className={styles.td}>
                <div className={styles.skeletonBar} style={{ width: NAME_WIDTHS[i % NAME_WIDTHS.length] }} />
                <div className={styles.skeletonBarSub} />
              </td>
              <td className={styles.td}><div className={styles.skeletonBar} style={{ width: '70%' }} /></td>
              <td className={styles.td}><div className={styles.skeletonBar} style={{ width: '40%' }} /></td>
              <td className={styles.td}><div className={styles.skeletonBar} style={{ width: '60%' }} /></td>
              <td className={styles.td}><div className={styles.skeletonBar} style={{ width: '50%' }} /></td>
              <td className={styles.td}><div className={styles.skeletonBar} style={{ width: '65%' }} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
